import * as React from 'react';
import {
    WithItemCache,
    IItemCacheStateProps,
} from '@ms/items-view/lib/private/components/withItemCache/WithItemCache';
import getAttachment from 'owa-attachment-model-store/lib/selectors/getAttachment';
import { getParameterStore } from '../store/ParametersStore';
import { AttachmentModel, TypeOfAttachment } from 'owa-attachment-model-store';
import { fileKeyFacet } from '../Schema/Facets';
import { getFieldRenderBarrier } from '@ms/items-view/lib/private/components/fields/FieldHelper';
import { DotDotDotField } from '@ms/items-view/lib/private/components/fields/dotdotdot/DotDotDotField';
import { Link } from 'office-ui-fabric-react/lib/Link';
import loc from 'owa-localize';
import { ActionsMenuTooltip, ActionsMenuAriaLabel } from '../strings.locstring.json';

const styles = require('./NameColumn.scss');

function onContextMenu(ev: React.MouseEvent<HTMLButtonElement>): void {
    const menuEvent = document.createEvent('CustomEvent');
    menuEvent.initCustomEvent('contextmenu', true /*canBubble*/, true /*cancelable*/, ev);
    ev.currentTarget.dispatchEvent(menuEvent);
}

export interface INameColumnProps {
    itemKey: string;
}

export class NameColumn extends React.PureComponent<INameColumnProps> {
    public render(): JSX.Element {
        const { itemKey } = this.props;

        return (
            <WithItemCache>
                {({ itemCache }: IItemCacheStateProps): JSX.Element => {
                    const parameterStore = getParameterStore();

                    let attachmentId = {
                        Id: itemCache.demandItemFacet(fileKeyFacet, itemKey).id,
                        mailboxInfo: parameterStore.mailboxInfo,
                    };
                    let attachment: AttachmentModel = getAttachment(attachmentId);

                    const pageLoadBarrier = getFieldRenderBarrier(itemCache);

                    const actionsMenu = (
                        <DotDotDotField
                            onClick={onContextMenu}
                            ariaLabel={loc(ActionsMenuAriaLabel)}
                            title={loc(ActionsMenuTooltip)}
                            pageLoadBarrier={pageLoadBarrier}
                        />
                    );

                    return (
                        <div className={styles.column}>
                            <div className={styles.nameContainer}>
                                <Link
                                    data-selection-invoke={true}
                                    className={
                                        attachment.type === TypeOfAttachment.Link
                                            ? styles.linkName
                                            : styles.name
                                    }
                                    title={attachment.model.Name}>
                                    {attachment.model.Name}
                                </Link>
                            </div>
                            <div className={styles.dotdotdot}>{actionsMenu}</div>
                        </div>
                    );
                }}
            </WithItemCache>
        );
    }
}
